var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-section",attrs:{"id":"teams"}},[_c('Team1'),_c('Team2'),_c('Team3'),_c('Team4'),_c('Team5')],1)}
var staticRenderFns = []

export { render, staticRenderFns }